import React, { BaseSyntheticEvent, ReactNode, useEffect, useRef } from 'react';
import {
  FieldValues,
  FormProvider,
  UseFormProps,
  UseFormReturn,
  useForm,
} from 'react-hook-form';

export const NakedForm = <T extends FieldValues = FieldValues>(props: {
  methods: UseFormReturn<T>;
  onSubmit: (
    data: T,
    event: BaseSyntheticEvent<object, unknown, unknown> | undefined,
    methods: UseFormReturn<T>,
  ) => void;
  children?: ReactNode;
  className?: string;
  autoFocus?: boolean;
  description?: ReactNode | string;
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (props.autoFocus && formRef.current) {
      const firstInput = formRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
        firstInput.select();
      }
    }
  }, [props.autoFocus]);

  return (
    <FormProvider {...props.methods}>
      {props.description && (
        <div className="block text-gray-600 space-y-1 text-sm dark:text-gray-200">
          {props.description}
        </div>
      )}
      <form
        onSubmit={props.methods.handleSubmit((a, event) =>
          props.onSubmit(a, event, props.methods),
        )}
        className={props.className}
        autoComplete="off"
        ref={formRef}
      >
        {props.children}
      </form>
    </FormProvider>
  );
};

export const Form = <T extends FieldValues = FieldValues>(props: {
  defaultValues: UseFormProps<T>['defaultValues'];
  onSubmit: (
    data: T,
    event: BaseSyntheticEvent<object, unknown, unknown> | undefined,
    methods: UseFormReturn<T>,
  ) => void;
  children?: ReactNode;
  className?: string;
  autoFocus?: boolean;
  description?: ReactNode | string;
}) => {
  const methods = useForm<T>({
    defaultValues: props.defaultValues,
  });

  return <NakedForm {...props} methods={methods} />;
};

// FormSection is a wrapper for FormProvider to allow nested forms
export const FormSection = <T extends FieldValues = FieldValues>(props: {
  methods: UseFormReturn<T>;
  children?: ReactNode;
  className?: string;
}) => {
  return (
    <FormProvider {...props.methods}>
      <div className={props.className}>{props.children}</div>
    </FormProvider>
  );
};
